import React from "react";
import logo from "../../../assets/images/greenshine/green shine logo 1 (1).png";
import { Link } from "react-scroll";
import { AiOutlineMenu, AiOutlineShop } from "react-icons/ai";
const Header = () => {
  return (
    <>
      <nav className="flex justify-between  md:hidden items-center px-5  w-full z-10 bg-white  py-2">
        <div>
          <div className="drawer absolute left-0  top-4 w-full ">
            <input id="my-drawer" type="checkbox" className="drawer-toggle" />
            <div className="drawer-content -z-50 ">
              <label htmlFor="my-drawer" className=" drawer-button">
                <AiOutlineMenu size={24} />
              </label>
            </div>
            <div className="drawer-side">
              <label htmlFor="my-drawer" className="drawer-overlay"></label>
              <ul className="menu p-4 w-80 h-full bg-[#2D2D2D] text-white  ">
                {/* Sidebar content here */}
                <li>
                  <img src={logo} className="w-44" alt="" />
                </li>
                <li>
                  <Link
                    activeClass="inline-block text-green-500"
                    to="section-1"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="inline-block text-green-500"
                    to="section-2"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="inline-block text-green-500"
                    to="section-3"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    Our Products
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="inline-block text-green-500"
                    to="section-4"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    Projects
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="inline-block text-green-500"
                    to="section-5"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <img src={logo} className="w-40" alt="" />
        </div>
        <a href="#" className="z-50 ">
          <AiOutlineShop size={24} />
        </a>
      </nav>
      <nav className="bg-white fixed hidden md:block z-20 w-full">
        <div className="flex px-10 py-4 justify-center items-center">
          <div className="shadow-inner">
            <img src={logo} className="w-44" alt="" />
          </div>
          <div className="ml-auto">
            <ul className="flex gap-6">
              <li className="nav-link cursor-pointer titlefont !text-lg">
                <Link
                  activeClass="border-b-2 pb-1 border-black"
                  to="section-1"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Home
                </Link>
              </li>

              <li className="nav-link cursor-pointer titlefont !text-lg">
                <Link
                  activeClass="border-b-2 pb-1 border-black"
                  to="section-2"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  About Us
                </Link>
              </li>
              <li className="nav-link cursor-pointer titlefont !text-lg">
                <Link
                  activeClass="border-b-2 pb-1 border-black"
                  to="section-3"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Our Products
                </Link>
              </li>
              <li className="nav-link cursor-pointer titlefont !text-lg">
                <Link
                  activeClass="border-b-2 pb-1 border-black"
                  to="section-4"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Projects
                </Link>
              </li>
              <li className="nav-link cursor-pointer titlefont !text-lg">
                <Link
                  activeClass="border-b-2 pb-1 border-black"
                  to="section-5"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
